var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.93,
    height: 51.105,
    viewBox: "0 0 52.93 51.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout-line",
    transform: "translate(-5 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M8.65,7.65h29.2V25.537H41.5V7.65A3.65,3.65,0,0,0,37.853,4H8.65A3.65,3.65,0,0,0,5,7.65v43.8A3.65,3.65,0,0,0,8.65,55.1h29.2a3.65,3.65,0,0,0,3.65-3.65H8.65Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M39.325,17.478a1.825,1.825,0,0,0-2.573,2.573l6.169,6.041H16.455a1.825,1.825,0,1,0,0,3.65H42.92l-6.169,6.315a1.825,1.825,0,1,0,2.573,2.573L49.984,28.046Z",
    transform: "translate(7.946 10.76)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exitIcon.7ecf26756e35e619fe3843f2113de7c3.svg";
export { ForwardRef as ReactComponent };